var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMetaverse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "6fbrq84h6a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B6FEB",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#623CD3",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#FFF",
    stroke: "url(#6fbrq84h6a)",
    strokeWidth: 3,
    transform: "translate(2 2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.288 27.64c-.67-3.294-2.091-7.706-6.415-7.818-.92-.027-1.952.084-3.068.308-.808.167-1.617.25-2.454.279v-3.407a.68.68 0 0 0-.67-.67.68.68 0 0 0-.669.67v3.407c-.836-.028-1.645-.14-2.454-.28a15.418 15.418 0 0 0-3.068-.307c-4.323.084-5.746 4.496-6.415 7.819-.753 3.657-1.004 6.45.14 8.153.557.81 1.394 1.312 2.482 1.507 2.845.503 5.55-1.73 7.447-6.087h5.076c1.701 3.965 4.072 6.143 6.638 6.143.25 0 .53-.028.78-.056 1.116-.195 1.953-.698 2.483-1.507 1.171-1.704.92-4.496.167-8.154zm-1.255 7.428c-.334.502-.864.81-1.617.95-3.124.53-5.216-3.52-5.969-5.278a1.335 1.335 0 0 0-1.227-.81h-5.076c-.53 0-1.004.307-1.228.81-.753 1.759-2.844 5.835-5.968 5.277-.753-.14-1.283-.447-1.618-.95-.948-1.395-.53-4.271.056-7.147.948-4.607 2.538-6.674 5.132-6.73h.195c.781 0 1.646.084 2.566.28 2.203.447 4.546.447 6.75 0a14.662 14.662 0 0 1 2.76-.28c2.623.056 4.212 2.15 5.133 6.73.641 2.876 1.06 5.752.111 7.148z",
    fill: "#6040D3",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.225 25.423h-1.35v-1.35a.342.342 0 0 0-.338-.338h-1.013a.342.342 0 0 0-.338.337v1.351h-1.35a.342.342 0 0 0-.338.338v1.013c0 .169.14.337.338.337h1.35v1.351c0 .169.141.338.338.338h1.013c.169 0 .338-.141.338-.338v-1.35h1.35c.17 0 .338-.141.338-.338V25.76a.342.342 0 0 0-.338-.338z",
    fill: "#BE82F3",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BE82F3",
    d: "M31.355 25.293h.227l.554-1.134.55 1.134h.228l-.758-1.558h-.038zM31.355 27.63h.227l.554 1.135.55-1.134h.228l-.758 1.558h-.038z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#564DD0",
    d: "M30.966 27.241v-.227l-1.135-.553 1.135-.55v-.228l-1.559.758v.038zM33.303 27.241v-.227l1.135-.553-1.135-.55v-.228l1.559.758v.038z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetaverse);
export default __webpack_public_path__ + "static/media/metaverse.0d3311aed3f9d9d2254fbb44bde1c17f.svg";
export { ForwardRef as ReactComponent };